import Input from "./Input";
import { Controller, useFormContext } from "react-hook-form";

export default function InputForm({ name, ...other }) {

    const { control } = useFormContext();
    return (
        <Controller
            name={name}
            control={control}
            render={({ field, fieldState: { error } }) => <Input {...field} error={error?.message} {...other} />}
        />
    );
}